import { useCallback, type MouseEvent } from 'react'
import moment from 'moment'
import { useIntl } from 'react-intl'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import { useIntlDateFormatter } from 'lib/datetime/dateUtils'
import { isModifiedClick } from 'tripPlanner/pages/chat/isModifiedClick'
import { getRecentChatTimestampLabel } from './recentChatTimestamp'
import { getRecentChatItemUrl, getRecentItemDisplayTitle, type RecentChatItem } from 'tripPlanner/pages/chat/recentChatItems'

interface Props {
  item: RecentChatItem
  /** Epoch milliseconds the relative timestamp is measured from. */
  now: number
  onClick: () => void
}

function ChatLandingRecentChatRow({ item, now, onClick }: Props) {
  const intl = useIntl()
  const formatDate = useIntlDateFormatter()
  const title = getRecentItemDisplayTitle(intl, item.title)

  const handleClick = useCallback((event: MouseEvent) => {
    if (!isModifiedClick(event)) {
      onClick()
    }
  }, [onClick])

  return (
    <ClickableListItem
      size="medium"
      title={title}
      titleLineClamp={1}
      subtitle={getRecentChatTimestampLabel(item.updatedAt, intl, formatDate, moment(now))}
      to={getRecentChatItemUrl(item)}
      onClick={handleClick}
    />
  )
}

export default ChatLandingRecentChatRow
